import { StateCreator } from "zustand";
import { MeetingType, fromApiMeetingType } from "../model/meeting_type";
import { MeetingTypesResource } from "../api/meeting_types";

export interface MeetingTypesSlice {
  meetingTypes: MeetingType[];
  loadMeetingTypes: () => Promise<void>;
  getTypeById: (id: string) => MeetingType | undefined;
}

export const createMeetingTypesSlice: StateCreator<
  MeetingTypesSlice,
  [],
  [],
  MeetingTypesSlice
> = (set, get) => ({
  meetingTypes: [],
  loadMeetingTypes: async () => {
    const apiMeetingTypes = await MeetingTypesResource.getList();
    const meetingTypes = apiMeetingTypes.map(fromApiMeetingType);
    meetingTypes.sort((a, b) => a.title?.localeCompare(b.title || "") || 0);
    console.log("Loaded meeting types", meetingTypes);
    set((_) => ({
      meetingTypes,
    }));
  },
  getTypeById: (id: string) => {
    const meetingTypes = get().meetingTypes;
    return meetingTypes.find((type) => type.id === id);
  },
});
